import { GtmDataLayer } from '../../data/gtmDataLayer'

export class Support {
    /**
     * Component that handles the step navigation, next and previous button.
     * @constructor
     * @param {Object} options
     * @param {Store} options.store
     */
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.id = options.titleId;
        this.$el = document.querySelector('.support');
        this.store.subscribe(this.update.bind(this));
    }

    setClickHandlers() { // eslint-disable-line class-methods-use-this
        const callButton = this.$el.querySelector('.support__call');

        callButton.addEventListener('click', () => {
            GtmDataLayer.contactSupport('call', this.state);
        });
    }

    render() {
        this.setClickHandlers();
    }

    update() {
        this.state = this.store.getState();
    };
}

export default Support;
